export default __webpack_public_path__ + "static/media/11.ca89d41a.png";